
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/impressionen/[slug]",
      function () {
        return require("private-next-pages/impressionen/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/impressionen/[slug]"])
      });
    }
  